import { useEffect, useState } from "react";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";

const provider = new GoogleAuthProvider();

function Header() {
  const [user, setUser] = useState(null);
  const [userPhoto, setUserPhoto] = useState(""); // Firestore에서 가져온 사진
  const [loggingIn, setLoggingIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      console.log("AUTH STATE:", currentUser);
      setUser(currentUser);
      setLoggingIn(false);

      if (currentUser) {
        // 로그인 시 Firestore에 사용자 정보 저장 (없으면 생성, 있으면 무시/업데이트)
        try {
          const userRef = doc(db, "users", currentUser.uid);
          const userSnap = await getDoc(userRef);
          const generateFriendCode = () => {
            const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
            let s = "";
            for (let i = 0; i < 6; i++) s += chars[Math.floor(Math.random() * chars.length)];
            return s;
          };
          
          if (!userSnap.exists()) {
            // 새 유저인 경우만 생성 (기존 isAdmin 필드 덮어쓰기 방지)
            await setDoc(userRef, {
              uid: currentUser.uid,
              email: currentUser.email,
              displayName: currentUser.displayName,
              photoURL: currentUser.photoURL,
              isAdmin: false, // 기본값은 관리자 아님
              friendCode: generateFriendCode(),
              createdAt: new Date()
            });
            setUserPhoto(currentUser.photoURL || "");
            console.log("User document created");
          } else {
            const userData = userSnap.data();
            // photoBase64가 있으면 그걸 사용, 없으면 기존 photoURL
            if (userData.photoBase64) {
              setUserPhoto(userData.photoBase64);
            } else {
              setUserPhoto(currentUser.photoURL || "");
            }

            // 기존 유저라면 정보 업데이트
            // 주의: displayName은 사용자가 변경했을 수 있으므로 덮어쓰지 않음
            // photoBase64도 Profile에서만 변경함
            await setDoc(userRef, {
              email: currentUser.email,
              lastLogin: new Date()
            }, { merge: true });

            // photoBase64 확인 및 적용
            if (userData.photoBase64) {
              setUserPhoto(userData.photoBase64);
            } else if (userData.photoURL) {
              // photoBase64가 없지만 photoURL(초기 가입 시 저장된 것)이 있다면 사용
              setUserPhoto(userData.photoURL);
            } else {
              setUserPhoto(currentUser.photoURL || "");
            }
            
            // friendCode가 없다면 생성해서 추가
            if (!userData.friendCode) {
              await setDoc(userRef, { friendCode: generateFriendCode() }, { merge: true });
            }
          }
        } catch (error) {
          console.error("Error creating/updating user document:", error);
          setUserPhoto(currentUser.photoURL || "");
        }
      } else {
        setUserPhoto("");
      }
    });

    return () => unsubscribe();
  }, []);

  const login = () => {
    navigate("/login");
  };

  const logout = async () => {
    await signOut(auth);
    navigate("/"); // 로그아웃 시 홈으로 이동
  };

  return (
    <header className="header">
      <div className="header-container">
        <h1 className="logo" onClick={() => navigate("/")} style={{cursor: 'pointer'}}>SolSNS</h1>
        <div className="auth-buttons">
          {user ? (
            <div className="user-profile">
              <button className="btn-secondary" onClick={() => navigate("/write")}>새 글 작성</button>
              <img 
                src={userPhoto || "https://via.placeholder.com/36"} 
                alt="Profile" 
                className="user-avatar"
                onClick={() => navigate("/profile")}
                style={{ cursor: "pointer" }}
              />
              <button className="btn-secondary" onClick={logout}>로그아웃</button>
            </div>
          ) : (
            <button 
              className="btn-primary" 
              onClick={login} 
            >
              로그인
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
